import { BaseModel } from "@blue-chip/core";

export default class ProjectReportCategory extends BaseModel {}
